$(()=>{
  $(".footer-block--menu").each(function(){    
    $(this).click(()=>{
      $(this).find('.footer-block__heading').toggleClass("footer-active");
      $(this).find('.footer-block__details-content').toggleClass("footer_content-active");
    });
  });
  // Tooltip Hover Effect in Product
  $('.product__info-container .tooltip-title').hover(function(){
     $('.product__info-container .tooltip-text').fadeToggle(); 
  });
});



// jQuery(document).ready(function($) {
// $('.popup-link').magnificPopup({
// type: 'image',
// gallery: {
// enabled: true
// }
// // Add other options as needed
// });
// });  

$(document).ready(function(){
    $('.custom-discounted-price').siblings('.price-item--regular').addClass('discounted-product-container');
});
$(document).ready(function() {
  $('.product-card-wrapper').each(function() {
    let $productCard = $(this);
    
    setTimeout(() => {
      if($productCard.find('.price-item--regular').hasClass('discounted-product-container')) {
        $productCard.find('.discount-sale-pr').css('visibility', 'visible');
      }
    }, 100);
  });
});


// PDP PAGE ZOOM EFFECT SCRIPT CHANGES
document.addEventListener('DOMContentLoaded', function () {
  const mediaItems = document.querySelectorAll('.template-product .product__media-item');
  const scale = 3;

  mediaItems.forEach(function (mediaItem) {
    mediaItem.addEventListener('mousemove', function (e) {
      const image = mediaItem.querySelector('img');
      const zoomContainer = mediaItem.querySelector('.image-magnify-lightbox');

      if (!image || !zoomContainer) return;

      const rect = image.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      zoomContainer.style.transformOrigin = `${(x / rect.width) * 100}% ${(y / rect.height) * 100}%`;
      zoomContainer.style.transform = `scale(${scale})`;
    });

    mediaItem.addEventListener('mouseleave', function () {
      const zoomContainer = mediaItem.querySelector('.image-magnify-lightbox');
      if (zoomContainer) {
        zoomContainer.style.transform = 'scale(1)';
      }
    });
  });
});


